export default function (t) {
  return [
    { title: t('general.code'), field: 'id' },
    { title: t('general.name'), field: 'name' },
    { title: t('general.active'), field: 'activeDescription' },
  ];
}
